import { ILocaleLegacy } from '@locales/interfaces';

/**
 * @deprecated
 * @todo
 * These are legacy translations. Some of them are used silently (come from BE), while others are outdated.
 * Please remove keys if you are 100% sure that they are not used in the project anymore.
 */
export const id = {
  IBCorporate: 'IB Perusahaan',
  IBIndividual: 'IB Individu',
  MAMIndividual: 'MAM Individu',
  MAMMasterWithLPOA: 'MAM Individu',
  MarkupConfirmation: 'Konfirmasi Kenaikan Harga',
  UserCorporate: 'User Corporate',
  UserIndividual: 'User Individual',
  UserJoint: 'User Joint',
  account: {
    bankingDetails: 'Rincian Perbankan',
    createANewAccount: 'Buat Akun Baru',
    register: 'Daftar',
    registerSignInTitle: 'Sudah menjadi Anggota?',
  },
  admin: {
    user: {
      fields: {
        isMam: 'Is MAM',
        isSales: 'Is Sales User',
      },
    },
    tabs: {
      tradingSettings: {
        tradingAccountSettings: 'Trading Account Settings',
        setIBCode: 'Set IB Code',
      },
    },
    reports: {
      ftdUtmReport: {
        headerTitle: 'FTD_UTM Report',
        menuTitle: 'FTD_UTM Report',
      },
    },
  },
  adminSocialTrading: {
    title: 'Perdagangan Sosial',
    investorAccountDetails: {
      tradingAccountName: 'Nama Akun Perdagangan',
      balance: 'Saldo',
      login: 'Log Masuk',
    },
    masterAccountDetails: {
      copyType: 'Jenis Salinan',
      groupMappingType: 'Group Mapping Type',
      login: 'Log Masuk',
    },
  },
  backgroundJobs: {
    recurring: {
      title: 'Recurring Jobs',
    },
  },
  bonuses: {
    collectBirthdayGift: 'Dapatkan hadiah ulang tahun Anda',
    availableTable: {
      bonusSize: 'Ukuran Bonus',
    },
  },
  errors: {
    shared: {
      recordWasNotFound: 'Rekaman tidak dapat ditemukan',
    },
    captcha: {
      captchaServerIsUnavailable:
        'Server Captcha tidak tersedia. Silakan perbarui halaman ini dan coba kembali. Jika masalah tetap terjadi, silakan hubungi dukungan melalui chat online atau email ke {{0}}',
    },
    files: {
      fileWasNotUploaded: 'File was not loaded',
    },
    mam: {
      linkIsInactive: 'Used link is not active',
    },
    trading: {
      profitSharingLimitWasExceeded:
        'Harap diperhatikan, bahwa pembagian hasil keuntungan telah melampaui batas maksimal. Batas maksimalnya adalah {{0}}%.',
      notEnoughMoney:
        'Mohon maaf, tetapi Anda tidak memiliki dana yang cukup di akun trading Anda untuk memproses penarikan yang diminta. Harap pastikan Anda memiliki saldo yang mencukupi sebelum mencoba melakukan penarikan. Harap diperhatikan bahwa selain saldo yang tersedia, Anda juga perlu mempertimbangkan tingkat margin bebas yang diperlukan untuk penarikan.',
    },
    copyTrading: {
      equityIsLessOrEqualZero: 'Akun Master tidak memenuhi syarat untuk disalin pada saat ini, silakan coba lagi nanti',
    },
    securityCode: {
      emptyValue: 'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) tidak boleh kosong atau nol',
      invalidLength: 'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) harus mengandung {{0}} karakter',
      invalidMinLength:
        'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) harus mengandung setidaknya {{0}} karakter',
      invalidMaxLength: 'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) tidak boleh melebihi {{0}} karakter',
      manyRepeatedValues:
        'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) tidak boleh memiliki lebih dari {{0}} karakter yang diulang',
      missingNumericValues: 'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) harus mengandung karakter angka',
      containsNumericValues:
        'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) tidak boleh mengandung nilai angka apa pun',
      missingLowerCaseValues:
        'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) harus mengandung karakter huruf kecil',
      containsLowerCaseValues:
        'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) tidak boleh mengandung nilai huruf kecil apa pun',
      missingUpperCaseValues:
        'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) harus mengandung karakter huruf besar',
      containsUpperCaseValues:
        'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) tidak boleh mengandung nilai huruf besar apa pun',
      missingSpecialValues:
        'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) harus mengandung karakter khusus',
      containsSpecialValues:
        'Nilai keamanan yang dimasukkan (kata sandi atau kode PIN) tidak boleh mengandung nilai karakter khusus apa pun',
      passwordChangeLimit: 'Password change attempts limit is exceeded. Please wait and try again',
    },
    user: {
      accountHasBeenDisabled: 'Mohon maaf atas ketidaknyamanan ini, tetapi akun {{0}} telah dinonaktifkan',
      ageIsAboveMaxAllowed:
        'Kami tidak menerima aplikasi dari siapapun yang berusia dibawah {{0}} tahun ataupun diatas {{1}} tahun',
      ageIsUnderMinAllowed: 'Kami tidak menerima aplikasi dari siapapun yang berusia dibawah {{0}} tahun',
      cantChangeLanguage: 'Cannot change language',
      fieldIsRequired: 'Field {{0}} is required',
      ibCodeIsIncorrect: "Kode IB '{{0}}' salah, silakan masukkan kode IB yang benar",
      invalidCredentials: 'Nama pengguna tidak valid {{0}} dan / atau kata sandi',
      invalidLengthOfPhoneNumber: 'Maaf, nomor ponsel {{0}} tidak valid. Silakan masukkan nomor ponsel yang benar',
      invalidLink: 'Tautan tidak valid',
      invalidPhoneNumberLength: 'Jumlah nomor telepon tidak valid, silakan coba lagi',
      onlyLatinCharactersAndDigitsAndSpecialSymbolsCanBeUsed:
        'Only latin characters, digits and special symbols can be used for {{0}} field',
      onlyLatinCharactersAndDigitsCanBeUsed: 'Only latin characters and digits can be used for {{0}} field',
      onlyLatinCharactersCanBeUsed: 'Only latin characters can be used for {{0}} field',
      onlyChineseCharactersCanBeUsed: 'Only chinese characters can be used for {{0}} field',
      personalDataNotEntered: 'Personal data are not entered',
      userCannotBeRestored:
        'Sorry, the record cannot be restored as the email or phone number of this profile is already in use with another profile, please delete the profile with the same email or phone number to restore this one',
      userDoesntExist: 'Pengguna {{0}} tidak ditemukan',
      userEmailAlreadyExists: 'Email pengguna telah terdaftar di sistem',
      userPhoneAlreadyExists: 'Nomor ponsel pengguna telah terdaftar di sistem',
      cantUpdateProfileActualStatus: 'Tidak dapat memperbarui akun {{0}}, status sebenarnya = {{1}}',
    },
  },
  formats: {
    formatFloat: '{{value, float}}',
    formatMoney: '{{value, money}}',
  },
  forms: {
    dragFile: 'Atau tarik berkas Anda kesini',
    exportFormat: 'Format Ekspor',
    getCode: 'Dapatkan José',
    hide: 'Sembunyikan',
    limitMessage: 'Karakter Tersisa {{limit}}',
    resend: 'Kirim Ulang',
    seconds: 'sec',
    show: 'Tampilkan',
  },
  headerWithBalance: {
    serverTime: 'Waktu Server',
    failedToFetchServerTime: 'Gagal untuk mendapatkan waktu server',
    view: 'Tampilan',
  },
  investors: {
    blackList: 'Daftar Hitam',
  },
  legal: {
    clientAgreement: 'Perjanjian Pelanggan',
    privacyPolicy: 'Kebijakan Prbadi',
  },
  legalTradingPlatform: {
    data: 'Data',
  },
  masterProfile: {
    aboutMaster: 'About Master',
    infoFields: {
      ibCode: 'IB code',
    },
  },
  masters: {
    fields: {
      masterNickname: 'Nama panggilan Master',
      rating: 'Posisi dalam peringkat',
    },
  },
  menu: {
    deposit: 'Deposito',
  },
  messages: {
    CopyTrading: {
      InvestorAccountWasLinked: "Akun pengikut mulai menyalin akun Master '{{MasterAccountName}}'.",
      InvestorAccountWasOpened:
        "Akun pengikut telah dibuat. Akun pengikut mulai menyalin akun Master '{{InvestorAccountName}}'.",
      InvestorAccountWasUnlinked: "Akun pengikut berhenti untuk menyalin akun Master '{{MasterAccountName}}'.",
      MasterAccountWasChanged:
        'Akun master telah diubah. (Bagi hasil = {{ProfitSharing}}, Metode alokasi = {{AllocationMethod}})',
      MasterAccountWasLinked: "Akun pengikut'{{InvestorAccountName}}' mulai menyalin akun Master.",
      MasterAccountWasOpened:
        'Akun master telah dibuat. (Bagi hasil = {{ProfitSharing}}, Metode alokasi = {{AllocationMethod}})',
      MasterAccountWasUnlinked: "Akun pengikut '{{InvestorAccountName}}' berhenti menyalin akun Master.",
    },
  },
  modal: {
    error: 'Kesalahan',
    notification: 'Notifikasi',
    ok: 'OK',
  },
  operationHistory: {
    filterName: 'Cari',
    placeholder: 'Silakan masuk',
  },
  pageTitles: {
    admin: {
      financialIdentity: {
        children: {
          cards: 'Cards',
        },
      },
    },
  },
  partnership: {
    salesTitle: 'Penjualan',
    ibInfo: {
      detailsTitle: 'Rincian IB',
      nextRebatePayment: 'Pembayaran Rabat Selanjutnya',
      statistics: {
        closetTradersReport: {
          type: 'Jenis',
        },
        tradingVolReport: {
          subIb: 'Sub-IB',
        },
      },
    },
    ibSettings: {
      referralLinkError: 'Nilai salah! Silakan hubungi tim dukungan kami untuk mendapatkan Nilai yang benar',
    },
    salesUserInfo: {
      aeCode: 'Kode AE',
    },
  },
  profile: {
    adult: 'Saya diatas 18 tahun',
    code: 'Kode',
    country: 'Negara',
    documentsUploaded: 'Dokumen sudah Terunggah',
    isAgreeWithTermsAndConditions: 'Saya terima <0>Syarat dan Ketentuan</0> dan <1>Kebijakan Pribadi</1>',
    pleaseValidateAccountToDeposit:
      'Rincian pribadi Anda perlu diverifikasi oleh tim kepatuhan {{brokerName}}. Sebelum melakukan deposit, Anda perlu menyerahkan salinan ID Anda.',
    successChangeDescription: 'Changes are saved!',
    warningMessage: {
      profileIsBeingVerified: 'Your profile is being verified, it might take a couple of seconds',
    },
  },
  psp: {
    accountsFetchFailErr: 'Gagal mendapatkan akun',
    confirmEveryTransaction: 'Konfirmasi setiap transaksi, deposit akan membutuhkan waktu sehingga 24 jam',
    deposit: {
      depositForm: {
        accountNameTitle: 'Nama Akun',
        addressLine2: 'Address Line 2',
        beneficiaryAccountNumberTitle: 'Nomor Rekening Penerima',
        beneficiaryBankHint: 'Silakan pilih nomor rekening bank',
        beneficiaryBankNameHint: 'Nama Bank, mis. (Standard Charted Bank)',
        cardNameTitle: 'Card Name',
        localDepositFileHint: 'Mohon lampirkan dokumen konfirmasi pembayaran jika diperlukan',
      },
      depositTitle: 'Dana Deposito',
      notice: 'Catatan! Penarikan hanya diperbolehkan untuk akun yang terverifikasi',
      warnToSubmitPersonalDetails:
        'Untuk melakukan deposit, harap kirimkan data pribadi Anda. Harap pastikan cocok dengan data di ID Anda',
    },
    localAgentTable: {
      login: 'Log Masuk',
    },
    operationsFetchFailErr: 'Gagal mendapatkan balasan dari operasi',
    operationsTable: {
      documentTitle: 'Dokumen',
      operationsTableTitle: 'Operasi Terbaru',
      paymentSystemTitle: 'Sistem Pembayaran',
    },
    pluginInfoFetchFailErr: 'Gagal mengambil informasi plugin',
    pluginNotFound: 'Plugin tidak ditemukan',
    pluginsFetchFailErr: 'Gagal mendapatkan plugin',
    preAuthorizedBanking: 'Pre-Authorized Banking',
    qrCodeCryptoNotice:
      'The QR Code is for one-time only. Do not scan this code in crypto application more than once, otherwise your payment will be suspended.',
    qrCodeCryptoTitle: 'QR Code for crypto application',
    resentOperationsTitle: 'Operasi Terbaru',
    transfer: {
      transactionDetailsTitle: 'Rincian Transaksi',
      transferForm: {
        amountError: 'Jumlah transfer yang tersedia telah melebihi',
        currencyTitle: 'Mata Uang',
      },
    },
    uploadBankStatementWithBankName:
      'Unggah Rekening koran atau laporan pernyataan bank yang berisi Nama Bank, Nama Penuh dan Nomor Rekening Bank Anda',
    uploadPayslip: 'Upload the bank payslip of your deposit',
    uploadYourDocument: 'Please confirm your deposit by uploading your bank statement',
    withdrawal: {
      notice: 'Penarikan hanya tersedia untuk akun yang Terverifikasi',
      withdrawalTitle: 'Penarikan Dana',
      withdrawalForm: {
        bankNameTitle: 'Nama Bank',
        beneficiaryCryptoWalletHint: 'A wallet number with cryptocurrency money will be sent to',
        beneficiaryCryptoWalletTitle: 'Beneficiary Crypto Wallet',
        confirmTitle: 'Konfirmasikan Informasi Penarikan',
      },
    },
  },
  settings: {
    docsForm: {
      documentNumberHint: 'Silakan periksa apakah nomor identifikasi dokumen sudah sama dengan yang ada di foto',
      documentTypeHint: 'Mohon pastikan Anda memberikan gambar dengan kualitas terbaik atau memindai dokumen yang sah',
      uploadedDocumentsTable: {
        docNameTitle: 'Nama Dokumen',
        documentNumber: 'Nomor dokumen',
        typeTitle: 'Jenis Dokumen',
      },
    },
    profileForm: {
      editProfileTitle: 'Edit Profil',
      proceedToDeposit: 'Lanjutkan ke Deposit',
      saveUserSuccessMessage: 'Profil telah berhasil disimpan',
      userDetailsErrorMessage: 'Gagal mendapatkan profil pengguna',
      verifyPersonalDetails: 'Verifikasi Rincian Pribadi',
      verifyProfileBtn: 'Verifikasi Profil',
    },
  },
  socialTradingModal: {
    copyHint:
      'Akun Anda {{account}} akan berhenti menyalin Master {{oldMaster}} dan akan memulai menyalin Master {{newMaster}}',
  },
  tradingAccounts: {
    accountDetailsTitle: 'Akun Trading',
    accountHistoryForm: {
      closeTimeTitle: 'Waktu Penutupan',
    },
    changeTradingAccountName: 'Ubah Nama Akun Perdagangan',
    connectedAccounts: 'Akun Terhubung',
    currency: 'Mata Uang',
    depositForm: {
      amountTitle: 'Jumlah',
      errorMessage: 'Gagal menyetorkan dana',
      successMessage: 'Deposito berhasil dibuat',
    },
    descriptionPlaceholder: 'Masukkan rekomendasi untuk pengikut Anda',
    fetchServersErr: 'Gagal mendapat balasan dari server',
    ibCode: 'IB (pilihan)',
    notRows: 'Tidak ada baris untuk ditampilkan',
    openAccountModalSubTitle: 'Rentang instrumen perdagangan terluas: mata uang, logam. Ketentuan perdagangan standar.',
    tradingPlatforms: 'Platform Perdagangan',
    transferForm: {
      title: 'Transfer Dana',
    },
    withdrawForm: {
      amountTitle: 'Jumlah',
      errorMessage: 'Gagal menyimpan Leverage',
      successMessage: 'Penarikan telah berhasil dibuat',
    },
  },
} satisfies ILocaleLegacy;
